export const navItems = [
  { id: "top", label: "首页" },
  { id: "feed", label: "更新快讯" },
  { id: "chapters", label: "章节列表" },
  { id: "audiobook", label: "有声书" },
  { id: "collections", label: "故事合集" },
  { id: "ranking", label: "热度榜" },
];

export const heroMeta = {
  eyebrow: "秘书题材 · 资源聚合专区",
  title: "善良的女秘书",
  subtitle: "阅读、收听、追更，一站看全",
  intro:
    "围绕善良的女秘书这一角色，本专区把小说全文、未删减版、有声书与故事合集收拢到同一处，并附上清晰的章节列表，方便你按顺序阅读，或直接跳到自己想听的那一段。",
  primaryCta: "从第一章开始阅读",
  secondaryCta: "收听有声书",
  coverMain:
    "https://readdy.ai/api/search-image?query=Elegant%20minimal%20literary%20book%20cover%20illustration%20of%20a%20poised%20young%20woman%20in%20office%20attire%20holding%20a%20document%20folder%2C%20warm%20terracotta%20and%20cream%20palette%2C%20soft%20flat%20illustration%20style%2C%20clean%20quiet%20background%2C%20premium%20publishing%20aesthetic%2C%20high%20detail&width=900&height=1200&seq=secretary-cover-main-01&orientation=portrait",
  coverSecond:
    "https://readdy.ai/api/search-image?query=Minimal%20warm%20novel%20cover%20with%20soft%20amber%20tones%20and%20simple%20geometric%20office%20motifs%2C%20flat%20vector%20illustration%2C%20elegant%20cream%20background%2C%20restrained%20lines%2C%20contemporary%20book%20design&width=600&height=800&seq=secretary-cover-second-02&orientation=portrait",
  stats: [
    { value: "326", label: "完整章节" },
    { value: "48.6万", label: "全文字数" },
    { value: "12小时", label: "有声时长" },
    { value: "9.4", label: "读者评分" },
  ],
};

export const feedItems = [
  {
    time: "今天 09:20",
    badge: "更新",
    title: "第326章《加班的夜晚》发布",
    desc: "主线迎来一次安静的转折，秘书与上级之间多了一句没说出口的话。",
  },
  {
    time: "昨天 21:05",
    badge: "有声",
    title: "有声书第 40 集上线",
    desc: "由「夜读电台」演绎，本集时长 26 分钟，附背景音效版本。",
  },
  {
    time: "3 天前",
    badge: "合集",
    title: "新增《办公室书信集》合集",
    desc: "收录 18 封往来书信体短篇，可独立阅读，也与主线彼此呼应。",
  },
  {
    time: "5 天前",
    badge: "修订",
    title: "未删减版第 1—80 章精校完成",
    desc: "修正标点与段落排版，补充两处人物背景说明，阅读更顺。",
  },
  {
    time: "1 周前",
    badge: "列表",
    title: "章节列表支持按卷筛选",
    desc: "全书划分五卷，列表页可直接定位到「初入职场」「并肩同行」等卷。",
  },
  {
    time: "2 周前",
    badge: "榜单",
    title: "本月热度榜更新",
    desc: "根据阅读与收听数据重新排序，前十名有三处变化。",
  },
];

export const chapters = [
  { no: 1, title: "入职第一天", words: "1,180字", tag: "免费" },
  { no: 2, title: "桌上的咖啡", words: "1,340字", tag: "免费" },
  { no: 3, title: "被退回的文件", words: "1,260字", tag: "" },
  { no: 4, title: "午后的会议", words: "1,520字", tag: "" },
  { no: 5, title: "雨天的伞", words: "1,410字", tag: "热门" },
  { no: 6, title: "她记住的名字", words: "1,290字", tag: "" },
  { no: 7, title: "加班到很晚", words: "1,660字", tag: "" },
  { no: 8, title: "一份手写便签", words: "1,350字", tag: "" },
  { no: 9, title: "电梯里的沉默", words: "1,220字", tag: "" },
  { no: 10, title: "年终的总结", words: "1,580字", tag: "热门" },
  { no: 11, title: "调岗通知", words: "1,440字", tag: "" },
  { no: 12, title: "第一次出差", words: "1,720字", tag: "" },
  { no: 13, title: "陌生城市的路", words: "1,530字", tag: "" },
  { no: 14, title: "深夜电话", words: "1,360字", tag: "" },
  { no: 15, title: "她没说出口", words: "1,490字", tag: "" },
  { no: 16, title: "旧档案柜", words: "1,310字", tag: "" },
  { no: 17, title: "一句谢谢", words: "1,400字", tag: "" },
  { no: 18, title: "新的开始", words: "1,560字", tag: "最新" },
];

export const audiobook = {
  totalEpisodes: 42,
  totalHours: "12小时18分",
  narrator: "夜读电台 · 清岚",
  cover:
    "https://readdy.ai/api/search-image?query=Minimal%20audiobook%20cover%20with%20soft%20headphones%20and%20an%20open%20book%20motif%2C%20warm%20amber%20and%20terracotta%20palette%2C%20flat%20illustration%2C%20clean%20cream%20background%2C%20calm%20evening%20reading%20mood&width=700&height=700&seq=secretary-audio-cover-01&orientation=squarish",
  episodes: [
    { no: 1, title: "入职第一天", duration: "18:24" },
    { no: 2, title: "桌上的咖啡", duration: "20:11" },
    { no: 3, title: "被退回的文件", duration: "19:47" },
    { no: 4, title: "午后的会议", duration: "22:35" },
    { no: 5, title: "雨天的伞", duration: "21:02" },
    { no: 6, title: "她记住的名字", duration: "19:58" },
    { no: 7, title: "加班到很晚", duration: "24:16" },
    { no: 8, title: "一份手写便签", duration: "20:40" },
  ],
};

export const collections = [
  {
    title: "办公室书信集",
    count: "18 篇",
    desc: "以书信体写成的独立短篇，彼此之间又留有线索引。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20story%20collection%20cover%20with%20a%20vintage%20typewriter%20and%20sealed%20envelope%20motif%2C%20terracotta%20and%20gold%20palette%2C%20flat%20illustration%2C%20clean%20textured%20cream%20background&width=600&height=800&seq=secretary-coll-letter-01&orientation=portrait",
  },
  {
    title: "午休的三十分钟",
    count: "12 篇",
    desc: "发生在午休时间的轻松片段，适合碎片时间单独阅读。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20minimal%20cover%20showing%20a%20coffee%20cup%20and%20notebook%20on%20a%20desk%2C%20soft%20amber%20and%20brown%20tones%2C%20flat%20illustration%2C%20plain%20cream%20background%2C%20quiet%20afternoon%20mood&width=600&height=800&seq=secretary-coll-noon-02&orientation=portrait",
  },
  {
    title: "加班的夜与清晨",
    count: "9 篇",
    desc: "城市夜灯下的独处与并肩，情绪更浓的一组故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20cover%20of%20a%20city%20skyline%20at%20dusk%20with%20warm%20office%20windows%2C%20deep%20teal%20and%20amber%20palette%2C%20flat%20illustration%2C%20clean%20calm%20background%2C%20urban%20evening%20atmosphere&width=600&height=800&seq=secretary-coll-night-03&orientation=portrait",
  },
  {
    title: "抽屉里的旧信",
    count: "15 篇",
    desc: "以回忆为主线讲过去的片段，补全几位配角的来路。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20cover%20with%20a%20stack%20of%20old%20letters%20tied%20with%20string%2C%20sepia%20and%20terracotta%20tones%2C%20flat%20illustration%2C%20plain%20parchment%20background%2C%20nostalgic%20mood&width=600&height=800&seq=secretary-coll-memory-04&orientation=portrait",
  },
  {
    title: "节日里的一枝花",
    count: "7 篇",
    desc: "围绕节日与礼物展开的温情短篇，节奏轻快。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20cover%20with%20a%20single%20rose%20on%20a%20notepad%2C%20soft%20coral%20and%20cream%20palette%2C%20flat%20illustration%2C%20clean%20light%20background%2C%20gentle%20festive%20tone&width=600&height=800&seq=secretary-coll-flower-05&orientation=portrait",
  },
];

export const rankings = [
  {
    rank: 1,
    title: "加班到很晚",
    meta: "第 7 章 · 阅读 42.1万",
    heat: "+18%",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20thumbnail%20cover%20with%20a%20desk%20lamp%20glowing%20at%20night%20over%20papers%2C%20warm%20amber%20tones%2C%20flat%20illustration%2C%20clean%20background&width=300&height=400&seq=secretary-rank-01&orientation=portrait",
  },
  {
    rank: 2,
    title: "雨天的伞",
    meta: "第 5 章 · 阅读 38.6万",
    heat: "+12%",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20thumbnail%20cover%20with%20a%20folded%20umbrella%20by%20a%20window%20and%20rain%2C%20muted%20green%20and%20cream%20tones%2C%20flat%20illustration&width=300&height=400&seq=secretary-rank-02&orientation=portrait",
  },
  {
    rank: 3,
    title: "年终的总结",
    meta: "第 10 章 · 阅读 35.2万",
    heat: "+9%",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20thumbnail%20cover%20with%20a%20clean%20report%20document%20and%20pen%2C%20terracotta%20and%20cream%20tones%2C%20flat%20illustration&width=300&height=400&seq=secretary-rank-03&orientation=portrait",
  },
  {
    rank: 4,
    title: "第一次出差",
    meta: "第 12 章 · 阅读 31.4万",
    heat: "+6%",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20thumbnail%20cover%20with%20a%20suitcase%20and%20train%20ticket%2C%20warm%20golden%20tones%2C%20flat%20illustration%2C%20clean%20background&width=300&height=400&seq=secretary-rank-04&orientation=portrait",
  },
  {
    rank: 5,
    title: "深夜电话",
    meta: "第 14 章 · 阅读 28.9万",
    heat: "+4%",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20thumbnail%20cover%20with%20an%20old%20telephone%20glowing%20at%20night%2C%20deep%20teal%20and%20amber%20tones%2C%20flat%20illustration&width=300&height=400&seq=secretary-rank-05&orientation=portrait",
  },
  {
    rank: 6,
    title: "桌上的咖啡",
    meta: "第 2 章 · 阅读 26.3万",
    heat: "+2%",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20thumbnail%20cover%20with%20a%20steaming%20coffee%20cup%20on%20a%20saucer%2C%20soft%20brown%20and%20cream%20tones%2C%20flat%20illustration&width=300&height=400&seq=secretary-rank-06&orientation=portrait",
  },
];

export const tags = [
  "都市职场",
  "情感细腻",
  "群像叙事",
  "短篇合集",
  "书信体",
  "慢节奏",
  "有声演绎",
  "未删减版",
  "第一卷",
  "第二卷",
  "治愈日常",
  "长篇连载",
];

export const readerNotes = [
  { name: "林小满", time: "3 小时前", text: "章节列表按卷分得很清楚，找第 12 章出差那段特别快。" },
  { name: "陈默", time: "昨天", text: "有声书的语速刚好，晚上通勤听正合适。" },
  { name: "阿柚", time: "2 天前", text: "书信集可以单独看，读完再回主线会更有味道。" },
];